
// // Slider


// var BlsSettingsSwiper = {
//     init: function() {
//         this.BlsSettingsCarousel()
//     },
//     BlsSettingsCarousel: function() {
//         document.querySelectorAll(".bls__swiper").forEach((e => {
//             this.BlsCarousel(e)
//         }))
//     },
//     BlsCarousel: function(e) {
//         var t, n = "true" === e?.dataset.autoplay,
//             o = "true" === e?.dataset.loop,
//             i = e?.dataset.slideshow ? e?.dataset.slideshow : 0,
//             s = e?.dataset.arrowCenterimage ? e?.dataset.arrowCenterimage : 0,
//             l = e?.dataset.desktop ? e?.dataset.desktop : 4,
//             r = e?.dataset.tablet ? e?.dataset.tablet : 2,
//             a = e?.dataset.mobile ? e?.dataset.mobile : 1,
//             c = e?.dataset.autoplaySpeed ? e?.dataset.autoplaySpeed : 3e3,
//             d = e?.dataset.speed ? e?.dataset.speed : 400,
//             u = e?.dataset.effect ? e?.dataset.effect : "slide",
//             m = e?.dataset.sectionId,
//             p = e?.dataset.row ? e?.dataset.row : 1,
//             h = e?.dataset.spacing ? e?.dataset.spacing : 0,
//             g = "true" === e?.dataset.paginationProgressbar,
//             f = "true" === e?.dataset.animationSrcoll,
//             v = window.innerWidth,
//             b = "true" === e?.dataset.itemMobile;
//         h = Number(h), c = Number(c), d = Number(d), n && (n = {
//             delay: c
//         }), t = new Swiper("#bls__swiper-" + m, {
//             slidesPerView: b ? "auto" : a,
//             spaceBetween: h >= 15 ? 15 : h,
//             autoplay: n,
//             loop: o,
//             effect: u,
//             speed: d,
//             watchSlidesProgress: !0,
//             watchSlidesVisibility: !0,
//             grid: {
//                 rows: p,
//                 fill: "row"
//             },
//             navigation: {
//                 nextEl: e.querySelector(".swiper-button-next"),
//                 prevEl: e.querySelector(".swiper-button-prev")
//             },
//             pagination: {
//                 clickable: !0,
//                 el: e.querySelector(".swiper-pagination"),
//                 type: g ? "progressbar" : "bullets"
//             },
//             breakpoints: {
//                 768: {
//                     slidesPerView: r,
//                     spaceBetween: h >= 30 ? 30 : h
//                 },
//                 1200: {
//                     slidesPerView: l,
//                     spaceBetween: h
//                 }
//             },
//         })
//     }
// };
// BlsSettingsSwiper.init(); 

var BlsSettingsSwiper = {
    
    init: function() {
        this.BlsSettingsCarousel();
    },
    BlsSettingsCarousel: function() {
        document.querySelectorAll(".bls__swiper").forEach((e => {
            this.BlsCarousel(e);
        }));
    },
    BlsCarousel: function(e) {
        var t, n = "true" === e?.dataset.autoplay,
            o = "true" === e?.dataset.loop,
            i = e?.dataset.slideshow ? e?.dataset.slideshow : 0,
            s = e?.dataset.arrowCenterimage ? e?.dataset.arrowCenterimage : 0,
            l = e?.dataset.desktop ? e?.dataset.desktop : 4,
            r = e?.dataset.tablet ? e?.dataset.tablet : 2,
            a = e?.dataset.mobile ? e?.dataset.mobile : 1,
            c = e?.dataset.autoplaySpeed ? e?.dataset.autoplaySpeed : 3e3,
            d = e?.dataset.speed ? e?.dataset.speed : 400,
            u = e?.dataset.effect ? e?.dataset.effect : "slide",
            m = e?.dataset.sectionId,
            p = e?.dataset.row ? e?.dataset.row : 1,
            h = e?.dataset.spacing ? e?.dataset.spacing : 0,
            g = "true" === e?.dataset.paginationProgressbar,
            f = "true" === e?.dataset.animationSrcoll,
            v = window.innerWidth,
            b = "true" === e?.dataset.itemMobile;
        h = Number(h), c = Number(c), d = Number(d), n && (n = {
            delay: c
        }), t = new Swiper("#bls__swiper-" + m, {
            slidesPerView: b ? "auto" : a,
            spaceBetween: h >= 15 ? 15 : h,
            autoplay: n,
            loop: o,
            effect: u,
            speed: d,
            watchSlidesProgress: !0,
            watchSlidesVisibility: !0,
            grid: {
                rows: p,
                fill: "row"
            },
            navigation: {
                nextEl: e.querySelector(".swiper-button-next"),
                prevEl: e.querySelector(".swiper-button-prev")
            },
            pagination: {
                clickable: !0,
                el: e.querySelector(".swiper-pagination"),
                type: g ? "progressbar" : "bullets"
            },
            breakpoints: {
                768: {
                    slidesPerView: r,
                    spaceBetween: h >= 30 ? 30 : h
                },
                1200: {
                    slidesPerView: l,
                    spaceBetween: h
                }
            },
        });
        console.log(m); 
        // Function to filter slides
        function filterSlides(category) {
            const slides = document.querySelectorAll('#bls__swiper-' + m +' .swiper-slide');
            // console.log("babas");
            // console.log("#bls__swiper-" + m);
            slides.forEach(slide => {
                if (category === 'all' || slide.getAttribute('data-category') === category) {
                    slide.style.display = 'flex'; // Show slide
                } else {
                    slide.style.display = 'none'; // Hide slide
                }
            }); 
            t.update(); // Update swiper to reflect changes
        }

        // Function to set active filter button
        function setActiveButton(activeButton) {
            const filterButtons = document.querySelectorAll('#bls__filter-' + m +' .filter-btn');
            filterButtons.forEach(button => {
                if (button === activeButton) {
                    button.classList.add('active');
                } else {
                    button.classList.remove('active');
                }
            });
        }

        // Setup filter buttons
        function setupFilterButtons() {
            const filterButtons = document.querySelectorAll('#bls__filter-' + m +' .filter-btn');
            filterButtons.forEach(button => {
                button.addEventListener('click', () => {
                    const filterValue = button.getAttribute('data-filter');
                    filterSlides(filterValue);
                    setActiveButton(button);
                });
            });
        }

        setupFilterButtons(); 
    }
};
BlsSettingsSwiper.init();

document.addEventListener("shopify:section:load", function(event) {
    BlsSettingsSwiper.init(); 
}); 